import React from 'react'

export const AmountCellSkeleton = () => {
  return (
    <div className="text-right flex items-center pr-40">
      <div className="h-3 rounded bg-gray-02 animate-pulse w-20" />
    </div>
  )
}
